module.exports = __webpack_public_path__ + "static/scale-model-of-paparazzi-celebrity-tours-in-los-angeles-california-53f66e25f4fb6bad671db08f6bfb8137.png";